export function initSpecModal() {
  document.addEventListener('click', (e: MouseEvent) => {
    const target = e.target as HTMLElement;

    const trigger = target.closest<HTMLButtonElement>('.spec-modal-trigger');
    if (trigger) {
      const modalId = trigger.dataset.modalId;
      if (!modalId) return;
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
      return;
    } 

    const closeBtn = target.closest<HTMLElement>('[data-modal-close]');
    if (closeBtn) {
      const modal = closeBtn.closest<HTMLElement>('.spec-modal');
      if (modal) closeModal(modal);
    }
  });

  document.addEventListener('keydown', (e: KeyboardEvent) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll<HTMLElement>('.spec-modal.is-open').forEach(closeModal);
  });
}

function closeModal(modal: HTMLElement) {
  modal.classList.remove('is-open');
  const anyOpen = document.querySelector('.spec-modal.is-open');
  if (!anyOpen) document.body.style.overflow = '';
}
